<template>
  <div v-if="productData" class="col-12 advCartRow" :product-id="productData.productId">
    <div v-if="miniCart">
      <div class="d-flex-100 text-center minicartItem">
        <div class="d-flex-100 miniCartSideItem" v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
          <div class="col-2 p-0 m-0"></div>
          <div class="col-10 p-0 m-0">
            <adv-cart-product-bundle-display
              class="col-12 p-0 m-0"
              :cart-product="cartProduct"
              :product-data="productData"
              style-type="smart"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex flex-wrap cart_item_info">
            <div class="minicart-item-thumb">
              <div class="thumbnail_container">
                <div class="thumbnail">
                  <img class="img-fluid" :src="imageSrc" :alt="productData.productName"/>
                </div>
              </div>
            </div>
            <div class="d-flex flex-wrap miniCartItemContent">
              <div class="cart_item_name">
                <span class="db-100">
                  {{ productData.productName }}
                </span>
                <div class="db-100 text-left minicart-price">
                  <div class="db-100 minicart-item-price">
                    {{ t('price') }} / {{ t('package') }}:
                    <span v-html="finalPriceWithSign"></span>
                  </div>
                  <span class="db-100">
                    {{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span>
                  </span>
                </div>
              </div>

              <button v-on:click="removeProductFromCart" :disabled="!onlineStatus" class="action-item rem-minicart-prod pt-0" v-if="!readOnly" aria-label="Αφαίρεση προϊόντος">
                <i class="lni lni-trash"></i>
              </button>

            </div>
            <div class="d-flex flex-wrap miniCartItemActions">
              <div class="minicartPriceMob">
                {{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span>
              </div>
              <div class="d-flex-100 miniCartQuantityCol">
                <div class="d-flex-100 minicart-input-col" v-if="!readOnly">
                  <adv-cart-input-spinner
                    class="quantitySpinner"
                    :key="cartProduct.quantity + (cartProduct.freeQuantity || 0)"
                    :product-code-id="cartProduct.productCodeId"
                    :quantity="cartProduct.quantity"
                    v-on:quantity-changed="updateProductQuantity">
                  </adv-cart-input-spinner>
                </div>
                <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
                <div class="col-12 text-left minicart-quantity" v-if="readOnly">
                  <span>
                    {{ t('quantity') }}: {{ cartProduct.quantity }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!miniCart">
      <div class="d-flex-100 minicart-item-row">
        <div class="col-12 text-center helpCartMsg m-3" v-show="cartError && !readOnly">
          <i class="ti-info-alt"></i> {{ cartError }}
        </div>
        <div class="col-2 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="imageSrc" :alt="productData.productName">
            </div>
          </div>
        </div>

        <div class="col-10 col-sm-4 col-md-6 col-lg-5 col-xl-6 minicart-item-title">
          <template v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
            <adv-cart-product-bundle-display
              class="col-12 p-0"
              :cart-product="cartProduct"
              :product-data="productData"
              :expanded="true"
              style-type="smart"
            />
          </template>
          <a class="db-100" :href="productData.productUrl">
            {{ productData.productName }}
          </a>
          <div class="d-flex-100 minicart-item-quantity" v-if="!readOnly">
            <adv-cart-input-spinner
              class="d-flex-100 quantitySpinner"
              :key="cartProduct.quantity + (cartProduct.freeQuantity || 0)"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
            <div class="d-flex-100 minicart-item-quantity advSpinnerRow" v-if="readOnly">
              {{ cartProduct.quantity }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap cartRowItemsCol">
          <!-- <div class="advCart-discount-row d-none" v-show="productData.productHasDiscount" >
            <span class="advCartDiscPerc">
              {{ productData.productDisclosure }}
            </span>
          </div> -->
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="db-100 minicart-item-price">
            {{ t('price') }} / {{ t('package') }}:
            <span v-html="finalPriceWithSign"></span>
          </div>
          <div class="db-100 advCartRowTotal">
            <span v-show="productData.productHasDiscount" class="advCartPrevPrice d-none" v-html="originalTotalPriceWithSign"></span>
            <span class="db-100 advCartFinalPrice">{{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span></span>
          </div>
        </div>
        <a href="#" v-on:click="removeProductFromCart"  v-if="!readOnly" :disabled="!onlineStatus" class="action-item">
          {{ t('delete') }}
        </a>
      </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-xs-12 advCartRowAttr">
          <span>
            {{ productCodeAttributes }}
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvCartInputSpinner from './AdvCartInputSpinner'
import AdvCartProductCustomizationDisplayValues
  from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AdvCartProductBundleDisplay from './AdvCartProductBundleDisplay.vue'

export default {
  name: 'AdvCartProductRow',
  components: {
    AdvCartProductCustomizationDisplayValues,
    AdvCartProductBundleDisplay,
    AdvCartInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign () {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalPriceWithSign () {
      return (this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate).toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalTotalPriceWithSign () {
      const price = this.productData.productFinalPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    productData () {
      const productData = store.getters.getProductById(this.cartProduct.productId)
      const cartProductData = store.getters.getCartProductById(this.cartProduct.productId)
      return {
        ...productData,
        ...cartProductData
      }
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1')['small'] : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: 0
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    },
    updateProductQuantity (quantity) {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: quantity + (this.cartProduct.freeQuantity || 0)
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    }
  }
}
</script>
